import EventEmitter from 'events';
import director from '../../director/director';
const EditViewContainerFactory=(manager, viewOptions)=>{
    let _emitter=new EventEmitter();
    //events
    const on = (event, handler) => {
        _emitter.on(event, handler);
    }

    const off = (event, handler) => {
        _emitter.removeListener(event, handler);
    }

    const once = (event, handler) => {
        _emitter.once(event, handler);
    }
    // function
    const showGreeting=()=>{
        return "Welcome to the Edit View";
    }
    return {
        message:showGreeting,
        on:on,
        off:off,
        once:once
    };
}
export default EditViewContainerFactory